export default "__VITE_ASSET__D4VL6PRL__";